<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 11 11"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M8.092 8.355a.75.75 0 0 1-1.184.92 1.794 1.794 0 0 0-1.42-.695c-.553 0-1.064.25-1.403.673a.75.75 0 1 1-1.17-.94A3.293 3.293 0 0 1 5.487 7.08c1.031 0 1.984.477 2.605 1.275zM2.5 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
